import * as actions from "../../../actions/laundry/report";

const initialState = {
  loading: false,
  items: [],
  pendingItems: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_LAUNDRYORDERS: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_LAUNDRYORDERS_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_LAUNDRYORDERS_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.GET_LAUNDRYORDERS_PENDING: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_LAUNDRYORDERS_PENDING_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_LAUNDRYORDERS_PENDING_SUCCESS: {
      return {
        ...state,
        pendingItems: payload ? payload : [],
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
